import React from 'react';
import './Home.css';
import mainlogo from '../assets/logo/logo_main.webp';
import discordIcon from '../assets/social/header-discord.svg';

import NFT_TEMPLATES from '../config/nftTemplates';
import WORKER_TEMPLATES from '../config/workerTemplates';
import PACK_TEMPLATES from '../config/packTemplates';
import {WORKER_PACK_TEMPLATES} from '../config/workerPackTemplates';

function Home() {
  return (
    <div className="home-container">
      <section className="hero">
        <div className="hero-left">
        </div>
        <div className="hero-right">
          <h1>Welcome to <span className="highlight">Ranchers Land</span></h1>
          <p>Stake. Produce. Craft. Trade. Earn.</p>
          <a className="cta-button" href="https://discord.gg/Rqsr8YpQuh" target="_blank" rel="noopener noreferrer">
            Join Community
          </a>
        </div>
      </section>

      <section className="section about-section">
        <div className="about-grid">
          <div className="about-visual">
            <img src={mainlogo} alt="Farm Visual" />
          </div>
          <div className="about-text">
            <h2>🌾 About the RanchersLand</h2>
            <p>
              RanchersLand is a <strong>blockchain farming simulator</strong> built on the <strong>WAX network</strong>, where players stake NFTs to generate tokens and manage stamina for optimized resource gain. With a <strong>robust economy</strong>, burn mechanics, and assistant automation, RanchersLand elevates <strong>play-to-earn sustainability</strong>.
            </p>
          </div>

        </div>
      </section>

      <section className="section">
        <h2>Gameplay</h2>
        <div className="game-features">
          <div className="feature-card">
            <h3>💰 Stake & Earn</h3>
            <p>Stake Tools, Workers, and Packs to generate RANCH, FARM, TOOL, and RCOIN tokens.</p>
          </div>
          <div className="feature-card">
            <h3>🔧 Repair & Craft</h3>
            <p>Use TOOL and FARM tokens to repair worn NFTs or mint brand-new assets.</p>
          </div>
          <div className="feature-card">
            <h3>🔥 Passive Burn System</h3>
            <p>0.25% of every external transfer is burned, reducing token supply steadily.</p>
          </div>
          <div className="feature-card">
            <h3>🤝 Assistant Support</h3>
            <p>Delegate trusted wallets for automation of low-risk tasks like stamina refill or claiming.</p>
          </div>
        </div>
      </section>
      <section className="section nft-showcase">
        <h2>Product NFTs</h2>
        <div className="nft-scroll-wrapper">
          <div className="nft-scroll-track">
            {[...NFT_TEMPLATES, ...NFT_TEMPLATES].map(nft => (
              <div key={nft.template_id + Math.random()} className="nft-card">
                <img src={nft.img} alt={nft.nft_name} />
                <p>{nft.type} / Generates: {nft.rewards ? nft.rewards.join(', ') : 'N/A'}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section nft-showcase">
        <h2>Workers</h2>
        <div className="nft-scroll-wrapper">
          <div className="nft-scroll-track">
            {[...WORKER_TEMPLATES, ...WORKER_TEMPLATES].map(worker => (
              <div key={worker.template_id + Math.random()} className="nft-card">
                <img src={worker.img} alt={worker.worker_name} />
                <h4>Type: {worker.type}</h4>
                <p>+{worker.additional_stamina} Stamina, Bonus Claims</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section nft-showcase">
        <h2>Packs</h2>
        <div className="nft-scroll-wrapper">
          <div className="nft-scroll-track">
            {[...PACK_TEMPLATES, ...PACK_TEMPLATES].map(pack => (
              <div key={pack.template_id + Math.random()} className="nft-card">
                <img src={pack.img} alt={pack.pack_name} />
                <h4>{pack.pack_name}</h4>
                <p>
                  Rewards: {pack.content_token || 'N/A'}<br />
                  {pack.content_token ? 'Stake and Claim.' : 'Unpack and Claim.'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section nft-showcase">
        <h2>Worker Packs</h2>
        <div className="nft-scroll-wrapper">
          <div className="nft-scroll-track">
            {[...WORKER_PACK_TEMPLATES, ...WORKER_PACK_TEMPLATES].map(pack => (
              <div key={pack.template_id + Math.random()} className="nft-card">
                <img src={pack.img} alt={pack.pack_name} />
                <h4>{pack.pack_name}</h4>
                <p>
                  Random Worker NFT<br />
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="discord-section">
        <div className="discord-wrapper">
          <img src={require('../assets/logo/logo_main.webp')} alt="Farmer Icon" className="discord-bg-icon left" />
          <div className="discord-content">
            <h2>Join Our Community</h2>
            <p>Connect with ranchers on Discord for updates & giveaways.</p>
            <a className="discord-button" href="https://discord.gg/Rqsr8YpQuh" target="_blank" rel="noopener noreferrer">
              <img src={discordIcon} alt="Discord Icon" /> Join Our Discord
            </a>
          </div>
          <img src={discordIcon} alt="Discord Background" className="discord-bg-icon" />
        </div>
      </section>
    </div>
  );
}

export default Home;